// Arabic modules 14 and 15 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision
// H-10. Identifiers, codes and time-zone names stay Latin and are isolated left-to-right (PD-012).
import type { enSafety } from './en-safety.ts';
import type { Message } from './types.ts';

export const arSafety: { readonly [K in keyof typeof enSafety]: Message } = {
  // ------------------------------------------------------------ reporting: definitions
  'rpt.def.operations.dashboard.title': 'لوحة التشغيل',
  'rpt.def.operations.dashboard.description': 'المتوقَّعون والواصلون والمنتظرون والموجودون والمتأخرون والمرفوضون والملغاة زياراتهم والمغادرون للمواقع والفترة المحددة.',
  'rpt.def.visits.summary.title': 'تقرير الزيارات',
  'rpt.def.visits.summary.description': 'أعداد الزيارات ونتائجها ومددها حسب الموقع أو اليوم أو نوع الزائر أو الجهة أو الوجهة أو الغرض أو المصدر.',
  'rpt.def.visits.exceptions.title': 'عدم الحضور والمغادرات غير المحسومة',
  'rpt.def.visits.exceptions.description': 'الزوار المجدولون الذين لم يصلوا، والأشخاص الذين لم تُحسم مغادرتهم بعد، مع سجل كل تصنيف.',
  'rpt.def.visits.hosts.title': 'نشاط المضيفين والأقسام',
  'rpt.def.visits.hosts.description': 'نشاط الزيارات حسب المضيف أو القسم، مع بيان طريقة نسبة القسم.',
  'rpt.def.contractors.compliance.title': 'حضور المقاولين والامتثال',
  'rpt.def.contractors.compliance.description': 'حضور المقاولين مع حالة الامتثال كما كانت عند كل وصول، إلى جانب وضع الشركة الحالي والتصاريح والإثباتات التي توشك على الانتهاء.',
  'rpt.def.vehicles.summary.title': 'المركبات والمواقف',
  'rpt.def.vehicles.summary.description': 'دخول المركبات وخروجها واستخدام المواقف وقراءات الكاميرات واللوحات غير المطابقة واستثناءات البوابة — تُعدّ منفصلة عن الأشخاص.',

  // ------------------------------------------------------------ reporting: metrics and definitions
  'rpt.metric.expected': 'المتوقَّعون',
  'rpt.metric.arrived': 'الواصلون',
  'rpt.metric.checked_out': 'المغادرون',
  'rpt.metric.denied': 'المرفوضون',
  'rpt.metric.cancelled': 'الملغاة',
  'rpt.metric.waiting': 'المنتظرون',
  'rpt.metric.onsite': 'في الموقع',
  'rpt.metric.uncertain': 'حضور غير مؤكد',
  'rpt.metric.overdue': 'متأخرون',
  'rpt.metric.people': 'الأشخاص في الفترة',
  'rpt.def.expected': 'المشاركون المسموح لهم بالحضور (مقدَّمة، معتمدة أو لا تحتاج اعتمادًا، غير محذوفين) التي تتقاطع نافذة زيارتهم مع الفترة.',
  'rpt.def.arrived': 'المشاركون الذين سُجِّل لهم وصول واحد على الأقل داخل الفترة.',
  'rpt.def.checked_out': 'المشاركون الذين تقع آخر مغادرة مسجّلة لهم داخل الفترة.',
  'rpt.def.denied': 'مشاركو زيارات الفترة الذين رُفض اعتمادهم.',
  'rpt.def.cancelled': 'مشاركو زيارات الفترة التي أُلغيت، أو الذين حُذفوا من الزيارة.',
  'rpt.def.waiting': 'فترات الانتظار المفتوحة في المواقع الآن.',
  'rpt.def.onsite': 'الأشخاص الذين آخر ملاحظة لهم وصول، الآن. حضور مسجّل وليس دليلًا على المكان.',
  'rpt.def.uncertain': 'الأشخاص الذين تتعارض ملاحظاتهم أو هي قيد المراجعة، الآن. لا يُعدّون في الموقع ولا مغادرين.',
  'rpt.def.overdue': 'الأشخاص المسجَّل وجودهم بعد انتهاء نافذة زيارتهم ومهلة السماح، الآن. مغادرتهم غير محسومة ولا تُفترض.',
  'rpt.def.people': 'المشاركون المختلفون الذين تتقاطع نافذة زيارتهم مع الفترة. الفئات أعلاه متداخلة: قد يكون الشخص متوقَّعًا وواصلًا ومغادرًا معًا.',
  'rpt.def.participants': 'المشاركون المختلفون (شخص واحد في زيارة واحدة).',
  'rpt.def.outcome.arrived': 'وصول مسجّل واحد على الأقل.',
  'rpt.def.outcome.cancelled': 'لم يصل؛ أُلغيت الزيارة أو حُذف الشخص.',
  'rpt.def.outcome.denied': 'لم يصل؛ رُفض الاعتماد.',
  'rpt.def.outcome.no_show': 'لم يصل رغم السماح له؛ صُنِّف عدم حضور بعد الموعد الفاصل.',
  'rpt.def.outcome.expected': 'لا شيء مما سبق بعد.',
  'rpt.def.duration': 'من أول وصول مسجّل إلى آخر مغادرة مسجّلة، فقط إذا كانت آخر ملاحظة مغادرة. الوسيط للمدد المعروفة.',
  'rpt.def.durationUnknown': 'المشاركون بلا مغادرة مسجّلة. مدتهم غير معروفة — ليست صفرًا وليست الوقت المنقضي حتى الآن.',
  'rpt.def.noShow': 'تصنيفات عدم الحضور السارية في الفترة.',
  'rpt.def.unresolved': 'تصنيفات المغادرة غير المحسومة السارية في الفترة.',
  'rpt.def.withdrawn': 'تصنيفات سُحبت لأن بيانات لاحقة نفتها. تُحفظ ولا تُحذف.',
  'rpt.metric.noShowActive': 'عدم حضور (سارٍ)',
  'rpt.metric.unresolvedActive': 'مغادرات غير محسومة (سارية)',
  'rpt.metric.withdrawn': 'تصنيفات مسحوبة',
  'rpt.metric.attendances': 'مرات الحضور',
  'rpt.metric.compliantAtArrival': 'ممتثل عند الوصول',
  'rpt.metric.nonCompliantAtArrival': 'غير ممتثل عند الوصول',
  'rpt.metric.workers': 'العمال',
  'rpt.def.attendances': 'وصول المقاولين المسجّل في الفترة.',
  'rpt.def.compliantAtArrival': 'حالات وصول كانت فيها حالة إثباتات المقاول «مقبولة» لحظة الوصول.',
  'rpt.def.nonCompliantAtArrival': 'حالات وصول كانت فيها حالة الإثباتات غير ذلك عند الوصول. التجديد اللاحق لا يغيّر ذلك.',
  'rpt.def.workers': 'الأشخاص المختلفون ضمن حالات الوصول هذه.',
  'rpt.metric.vehicleEntries': 'دخول المركبات',
  'rpt.metric.vehicleExits': 'خروج المركبات',
  'rpt.metric.distinctVehicles': 'مركبات مختلفة',
  'rpt.metric.anprReads': 'قراءات الكاميرا',
  'rpt.metric.anprDuplicates': 'قراءات مكررة (غير محسوبة)',
  'rpt.metric.unmatchedReads': 'قراءات غير مطابقة أو غير واضحة',
  'rpt.metric.gateExceptions': 'استثناءات البوابة',
  'rpt.metric.parkingAllocations': 'تخصيصات المواقف',
  'rpt.metric.vehiclesOnsiteNow': 'المركبات في الموقع الآن',
  'rpt.def.vehicleEntries': 'حركات دخول المركبات المسجّلة في الفترة باستثناء الملغاة. قراءات الكاميرا وحدها ليست دخولًا.',
  'rpt.def.vehicleExits': 'حركات خروج المركبات المسجّلة في الفترة باستثناء الملغاة.',
  'rpt.def.distinctVehicles': 'المركبات المختلفة التي لها دخول في الفترة.',
  'rpt.def.anprReads': 'قراءات اللوحات في الفترة، وتُحسب القراءة المكررة للوحة نفسها مرة واحدة.',
  'rpt.def.anprDuplicates': 'قراءات مكررة للوحة نفسها من الكاميرا نفسها خلال نافذة التكرار. تُعرض ولا تُضاف إلى الوصول.',
  'rpt.def.unmatchedReads': 'قراءات لم تطابق أي مركبة أو طابقت عدة مركبات أو كانت غير مقروءة أو منخفضة الثقة.',
  'rpt.def.gateExceptions': 'استثناءات اللوحات المرفوعة للمراجعة في الفترة.',
  'rpt.def.parkingAllocations': 'تخصيصات المواقف التي يتقاطع وقتها مع الفترة.',
  'rpt.def.vehiclesOnsiteNow': 'المركبات التي آخر حركة مسجّلة لها دخول، الآن.',

  // ------------------------------------------------------------ reporting: columns, groups, values
  'rpt.col.site': 'الموقع',
  'rpt.col.timeZone': 'المنطقة الزمنية',
  'rpt.col.visits': 'الزيارات',
  'rpt.col.participants': 'المشاركون',
  'rpt.col.durationKnown': 'مدد معروفة',
  'rpt.col.durationUnknown': 'مدد غير معروفة',
  'rpt.col.durationMean': 'متوسط المدة (دقيقة)',
  'rpt.col.durationMedian': 'وسيط المدة (دقيقة)',
  'rpt.col.reference': 'المرجع',
  'rpt.col.visitor': 'الزائر',
  'rpt.col.organisation': 'الجهة',
  'rpt.col.category': 'نوع الزائر',
  'rpt.col.host': 'المضيف',
  'rpt.col.department': 'القسم',
  'rpt.col.windowStart': 'بداية النافذة',
  'rpt.col.arrival': 'الوصول',
  'rpt.col.departure': 'المغادرة',
  'rpt.col.duration': 'المدة (دقيقة)',
  'rpt.col.outcome': 'النتيجة',
  'rpt.col.exception': 'الاستثناء',
  'rpt.col.classification': 'التصنيف',
  'rpt.col.classifiedAt': 'وقت التصنيف',
  'rpt.col.withdrawnAt': 'وقت السحب',
  'rpt.col.withdrawnReason': 'سبب السحب',
  'rpt.col.worker': 'العامل',
  'rpt.col.company': 'الشركة',
  'rpt.col.companyStatusNow': 'حالة الشركة الآن',
  'rpt.col.evidenceAtArrival': 'الإثباتات عند الوصول',
  'rpt.col.evidenceNow': 'الإثباتات الآن',
  'rpt.col.approvalAtArrival': 'الاعتماد عند الوصول',
  'rpt.col.activePermitsNow': 'التصاريح المعتمدة الآن',
  'rpt.col.evidenceExpiredNow': 'إثباتات مقبولة منتهية الآن',
  'rpt.col.evidenceExpiring30': 'إثباتات تنتهي خلال 30 يومًا',
  'rpt.group.none': 'الإجمالي',
  'rpt.group.site': 'الموقع',
  'rpt.group.day': 'اليوم',
  'rpt.group.category': 'نوع الزائر',
  'rpt.group.host': 'المضيف',
  'rpt.group.department': 'القسم',
  'rpt.group.organisation': 'الجهة',
  'rpt.group.destination': 'الوجهة',
  'rpt.group.purpose': 'الغرض',
  'rpt.group.source': 'المصدر (مخطط / دون موعد)',
  'rpt.outcome.arrived': 'وصل',
  'rpt.outcome.cancelled': 'ملغاة',
  'rpt.outcome.denied': 'مرفوض',
  'rpt.outcome.no_show': 'لم يحضر',
  'rpt.outcome.expected': 'متوقَّع / معلّق',
  'rpt.exception.no_show': 'عدم حضور',
  'rpt.exception.unresolved_departure': 'مغادرة غير محسومة',
  'rpt.classification.active': 'سارٍ',
  'rpt.classification.withdrawn': 'مسحوب',
  'rpt.withdrawn.arrival_recorded': 'سُجِّل الوصول لاحقًا',
  'rpt.withdrawn.departure_recorded': 'سُجِّلت المغادرة',
  'rpt.withdrawn.no_longer_applicable': 'لم يعد ينطبق',
  'rpt.basis.now': 'الآن',
  'rpt.basis.siteLocal': 'اليوم التقويمي المحلي لكل موقع',
  'rpt.basis.utc': 'يوم UTC التقويمي لكل المواقع',
  'rpt.unknown': 'غير معروف',

  // ------------------------------------------------------------ reporting: notes
  'rpt.note.overlapping': 'هذه الأرقام متداخلة: قد يكون الشخص الواحد متوقَّعًا وواصلًا ومغادرًا في الفترة نفسها. لا تُجمع أبدًا كأنهم أشخاص مختلفون.',
  'rpt.note.nowMetrics': 'المنتظرون والموجودون وغير المؤكدين والمتأخرون يصفون اللحظة الحالية مهما كانت الفترة المختارة.',
  'rpt.note.presenceNotLocation': 'الحضور هو ما سُجّل في المكاتب والأكشاك والبوابات — وليس دليلًا على مكان الشخص فعليًا.',
  'rpt.note.durationDefinition': 'تبدأ المدة من أول وصول مسجّل وتنتهي بآخر مغادرة مسجّلة. دون مغادرة مسجّلة تكون المدة غير معروفة.',
  'rpt.note.outcomeExclusive': 'لكل مشارك نتيجة واحدة فقط، لذا يساوي مجموع أعمدة النتائج عدد المشاركين.',
  'rpt.note.attributionHistorical': 'الأقسام كما سُجّلت عند إسناد المضيف إلى كل زيارة؛ النقل اللاحق لا ينقل الزيارات السابقة.',
  'rpt.note.attributionCurrent': 'الأقسام كما هي اليوم: المضيف الذي انتقل إلى قسم آخر يأخذ زياراته السابقة معه في هذا العرض.',
  'rpt.note.daySiteLocal': 'الأيام هي الأيام التقويمية المحلية لكل موقع.',
  'rpt.note.dayUtc': 'الأيام هي أيام UTC التقويمية لكل المواقع.',
  'rpt.note.exceptionHistory': 'تُحفظ التصنيفات عندما تسحبها بيانات لاحقة، مع السبب.',
  'rpt.note.noShowCutoff': 'يصبح الزائر المسموح له «عدم حضور» بعد الموعد الفاصل للموقع (افتراضيًا نهاية نافذة الزيارة) دون وصول.',
  'rpt.note.complianceAtArrival': '«عند الوصول» يعتمد الحقائق المسجّلة لحظة رصد الوصول. التجديد أو القبول اللاحق لا يجعل حضورًا سابقًا ممتثلًا.',
  'rpt.note.evidenceRollup': 'حالة الإثباتات لأنواع زوار المقاولين هي محصلة متطلبات المقاول (إثباتات الشركة والعامل والتصريح).',
  'rpt.note.vehicleSeparate': 'تُعدّ حركات المركبات منفصلة عن الأشخاص وعن قراءات الكاميرا.',
  'rpt.note.anprDuplicates': 'اللوحة التي تقرؤها الكاميرا نفسها مرارًا تُحسب مرة واحدة؛ وتُعرض التكرارات منفصلة.',

  // ------------------------------------------------------------ reporting: exports
  'rpt.sheet.data': 'التقرير',
  'rpt.sheet.about': 'عن هذا التصدير',
  'rpt.export.generatedAt': 'وقت الإنشاء',
  'rpt.export.scope': 'النطاق',
  'rpt.export.definition': 'التقرير',
  'rpt.export.period': 'الفترة',
  'rpt.export.timeBasis': 'حدود الأيام',
  'rpt.export.grouping': 'التجميع',
  'rpt.export.requestedBy': 'طلبه',
  'rpt.export.digest': 'بصمة عوامل التصفية',
  'rpt.export.note': 'ملاحظة',
  'rpt.export.personalData': 'سرّي — يحتوي على بيانات شخصية. تعامل معه وفق قواعد حماية البيانات في مؤسستك واحذفه عند انتهاء الحاجة إليه.',
  'rpt.export.truncated': 'قُطع هذا التصدير عند حدّ الصفوف. ضيّق عوامل التصفية للحصول على تصدير كامل.',
  'rpt.export.openReviews': { one: 'سجل حضور واحد قيد المراجعة؛ أرقام الحضور تشمل سجلات غير مؤكدة.', other: '{count} سجلات حضور قيد المراجعة؛ أرقام الحضور تشمل سجلات غير مؤكدة.' },
  'rpt.filter.locations': 'الوجهات',
  'rpt.filter.categories': 'أنواع الزوار',
  'rpt.filter.organisations': 'الجهات',
  'rpt.filter.hosts': 'المضيفون',
  'rpt.filter.states': 'النتائج / الحالات',

  // ------------------------------------------------------------ audit export and detail
  'audit.export.title': 'تصدير سجل التدقيق في Passage',
  'audit.export.confidential': 'سرّي — سجلات تدقيق. يُسجَّل التصدير في سجل التدقيق.',
  'audit.export.changesWithheld': 'طُلبت قيم قبل/بعد لكنها حُجبت: تحتاج صلاحية التدقيق الحساس على النطاق كله.',
  'audit.export.window': 'النافذة الزمنية',
  'audit.export.allScope': 'كل المواقع ضمن النطاق والأحداث على مستوى المؤسسة',
  'audit.filter.action': 'الإجراء',
  'audit.filter.actor': 'المنفّذ',
  'audit.filter.outcome': 'النتيجة',
  'audit.filter.resourceType': 'نوع السجل',
  'audit.filter.resourceId': 'السجل',
  'audit.filter.correlation': 'مرجع الربط',
  'audit.col.actor': 'المنفّذ',
  'audit.col.resource': 'السجل',
  'audit.col.correlation': 'مرجع الربط',
  'audit.col.changes': 'قبل / بعد',

  // ------------------------------------------------------------ API messages and validation
  'rpt.api.entitlement': 'يحتاج هذا التقرير إلى إضافة لا تملكها مؤسستك.',
  'rpt.api.multiSite': 'التقارير عبر عدة مواقع تحتاج إلى قدرة تعدد المواقع. اختر موقعًا واحدًا.',
  'rpt.api.staleFilter': 'تغيّرت عوامل التصفية منذ عرض هذه النتائج. شغّل التقرير مجددًا ثم صدّر.',
  'rpt.api.exportExpired': 'انتهت صلاحية هذا التصدير. اطلب تصديرًا جديدًا.',
  'rpt.api.exportNotReady': 'هذا التصدير غير جاهز للتنزيل.',
  'rpt.v.sites': 'اختر موقعًا واحدًا على الأقل.',
  'rpt.v.rangeOrder': 'يجب ألا تسبق النهاية البداية.',
  'rpt.v.rangeTooLong': 'اختر فترة لا تتجاوز 366 يومًا.',
  'rpt.v.grouping': 'لا يمكن تجميع هذا التقرير بهذه الطريقة.',
  'rpt.v.recipients': 'اختر مستلمًا واحدًا على الأقل.',
  'rpt.v.recipientUnknown': 'يجب أن يكون كل مستلم مستخدمًا نشطًا في هذه المؤسسة.',
  'audit.v.rangeRequired': 'حدّد بداية ونهاية للبحث في سجل التدقيق.',
  'audit.v.rangeBroad': 'البحث دون منفّذ أو سجل أو مرجع يغطي 31 يومًا على الأكثر.',
  'audit.v.rangeNarrow': 'يغطي البحث 366 يومًا على الأكثر.',
  'saf.api.musterOpen': 'يوجد تجمّع مفتوح لهذا الموقع بالفعل. تابعه بدلًا من بدء تجمّع آخر.',
  'saf.api.musterClosed': 'هذا التجمّع مغلق. سجله نهائي.',
  'saf.api.nothingToReconcile': 'لا يوجد تعارض لتسويته لهذا الشخص.',
  'saf.api.reviewResolved': 'تمت تسوية مراجعة الحضور هذه بالفعل.',
  'saf.api.sourceExists': 'يوجد مصدر حضور بهذا المفتاح في هذا الموقع بالفعل.',
  'saf.api.sourceDisabled': 'مصدر الحضور هذا معطّل.',
  'saf.api.exportExpired': 'انتهت صلاحية تصدير القائمة هذا. أنشئ تصديرًا جديدًا.',
  'saf.api.exportIntegrity': 'تعذّر إعادة إنتاج القائمة كما أُنشئت تمامًا. أنشئ تصديرًا جديدًا.',
  'saf.v.sourceKey': 'استخدم من 1 إلى 64 حرفًا لاتينيًا صغيرًا أو رقمًا أو نقطة أو شرطة أو شرطة سفلية.',
  'saf.v.confirm': 'أكّد أنك قرأت تحذير حداثة البيانات.',
  'saf.v.basis': 'هذه الملاحظة لا تخص هذا الشخص.',
  'saf.v.beforeSnapshot': 'لا يمكن أن تسبق الملاحظة لقطة القائمة.',
  'saf.v.reconcileNote': 'اشرح كيف سوّيت الملاحظات المتعارضة.',
  'saf.v.watermarkFuture': 'لا يمكن لمصدر أن يؤكد ملاحظات في المستقبل.',

  // ------------------------------------------------------------ roster export and values
  'saf.export.title': 'قائمة تجمّع Passage',
  'saf.export.drill': 'تمرين — هذا تجمّع تدريبي.',
  'saf.export.emergency': 'تجمّع طوارئ',
  'saf.export.notLocation': 'تسرد هذه القائمة الملاحظات المسجّلة. ليست دليلًا على المكان الفعلي لأي شخص: تحقّق من كل شخص.',
  'saf.export.generated': 'أُنشئت {time}. أي شيء سُجّل بعد هذا الوقت ليس في هذه الصفحة.',
  'saf.export.stale': 'خطر بيانات قديمة: عند اللقطة لم تُبلغ بعض مصادر الحضور مؤخرًا ({sources}). قد يكون أشخاص مفقودين من القائمة أو مدرجين خطأً.',
  'saf.export.freshnessAtSnapshot': 'مصادر الحضور عند اللقطة: مؤكَّدة حتى {time}.',
  'saf.export.unresolved': { one: 'كان شخص واحد متأخرًا (مغادرة غير محسومة) عند اللقطة.', other: 'كان {count} أشخاص متأخرين (مغادرة غير محسومة) عند اللقطة.' },
  'saf.export.reviews': { one: 'كان سجل حضور واحد قيد المراجعة عند اللقطة.', other: 'كانت {count} سجلات حضور قيد المراجعة عند اللقطة.' },
  'saf.export.site': 'الموقع',
  'saf.export.snapshotAt': 'لقطة القائمة',
  'saf.export.asOf': 'نداء الأسماء حتى',
  'saf.export.assembly': 'نقطة التجمّع',
  'saf.export.totals': 'الحدث كاملًا',
  'saf.export.filtered': 'هذه الصفحة (مصفّاة)',
  'saf.totals.line': '{roster} في القائمة · {accounted} معروف وضعهم · {unaccounted} غير معروف وضعهم',
  'saf.freshness.synchronousOnly': 'كل المصادر تسجّل مباشرة في Passage',
  'saf.col.name': 'الاسم',
  'saf.col.kind': 'النوع',
  'saf.col.organisation': 'الجهة',
  'saf.col.host': 'المضيف المسؤول',
  'saf.col.destination': 'الوجهة / المنطقة',
  'saf.col.atSnapshot': 'عند اللقطة',
  'saf.col.lastObserved': 'آخر ملاحظة',
  'saf.col.rollCall': 'نداء الأسماء',
  'saf.col.observer': 'المراقِب',
  'saf.col.observedAt': 'وقت الملاحظة',
  'saf.col.lateFacts': 'حقائق لاحقة',
  'saf.flag.overdue': 'متأخر',
  'saf.kind.visitor': 'زائر',
  'saf.kind.contractor': 'مقاول',
  'saf.kind.courier': 'مندوب توصيل',
  'saf.occupancy.onsite': 'مسجّل في الموقع',
  'saf.occupancy.uncertain': 'حضور غير مؤكد',
  'saf.rollcall.safe': 'بأمان',
  'saf.rollcall.missing': 'مفقود',
  'saf.rollcall.departed': 'غادر',
  'saf.rollcall.unknown': 'غير معروف',
  'saf.rollcall.needs_assistance': 'يحتاج مساعدة',
  'saf.rollcall.not_checked': 'لم يُتحقق بعد',
  'saf.rollcall.conflict': 'بلاغات متعارضة',
  'saf.late.departed_before_snapshot': 'غادر قبل اللقطة (سُجّل لاحقًا)',
  'saf.late.departed_after_snapshot': 'سُجّلت مغادرة بعد اللقطة',
  'saf.late.arrived_after_snapshot': 'وصل بعد اللقطة',
  'saf.late.returned_after_snapshot': 'سُجّل وصول بعد اللقطة',

  // ------------------------------------------------------------ email
  'saf.mail.drill': 'تمرين',
  'saf.mail.emergency': 'طوارئ',
  'saf.mail.subject': 'بدأ تجمّع في {site}',
  'saf.mail.body': 'عزيزي/عزيزتي {name}،\n\nبدأ تجمّع في {site}. نقطة التجمّع: {assembly}.\n\nأنت المضيف المسؤول عن {count} شخص/أشخاص في القائمة: {people}.\n\nإن كنت تعرف أين هم، فأبلغ منسّق الطوارئ. اتبع إجراءات الطوارئ في موقعك؛ هذه الرسالة ليست إنذارًا.',
  'rpt.mail.subject': 'تقريرك المجدول «{report}» جاهز',
  'rpt.mail.body': 'عزيزي/عزيزتي {name}،\n\nتقريرك المجدول «{report}» جاهز في Passage حتى {expires}. سجّل الدخول لتنزيله؛ يُعاد التحقق من صلاحيتك عند التنزيل.\n\nالتقرير نفسه غير مرفق بهذه الرسالة.',

  // ------------------------------------------------------------ safety UI (module 14)
  'saf.ui.title': 'الإشغال والتجمّع',
  'saf.ui.intro': 'تتبّع الأشخاص. أظهر عدم اليقين. الحضور هنا هو ما سجّلته المكاتب والأكشاك والبوابات — وليس دليلًا على مكان أي شخص.',
  'saf.ui.tab.occupancy': 'الإشغال الحي',
  'saf.ui.tab.muster': 'التجمّع',
  'saf.ui.tab.reviews': 'مراجعات الحضور',
  'saf.ui.tab.sources': 'مصادر الحضور',
  'saf.ui.tab.settings': 'إعدادات السلامة',
  'saf.ui.m.onsite': 'مسجّلون في الموقع',
  'saf.ui.m.onsiteSub': 'آخر ملاحظة وصول',
  'saf.ui.m.uncertain': 'حضور غير مؤكد',
  'saf.ui.m.uncertainSub': 'متعارض أو قيد المراجعة',
  'saf.ui.m.overdue': 'متأخرون',
  'saf.ui.m.overdueSub': 'مغادرة غير محسومة ولا تُفترض',
  'saf.ui.m.vehicles': 'مركبات في الموقع',
  'saf.ui.m.vehiclesSub': 'تُعدّ منفصلة عن الأشخاص',
  'saf.ui.freshness.title': 'مصادر الحضور حديثة',
  'saf.ui.freshness.staleTitle': 'خطر بيانات قديمة',
  'saf.ui.freshness.synchronous': 'كل مصدر يسجّل مباشرة في Passage؛ لا توجد تغذية متأخرة.',
  'saf.ui.freshness.watermark': 'التغذيات مؤكَّدة الاكتمال حتى',
  'saf.ui.freshness.neverReported': { one: 'تغذية واحدة لم تُبلغ قط.', other: '{count} تغذيات لم تُبلغ قط.' },
  'saf.ui.freshness.staleSources': 'لم تُبلغ مؤخرًا:',
  'saf.ui.freshness.lastRecorded': 'آخر ملاحظة مسجّلة:',
  'saf.ui.freshnessAtSnapshot': 'مصادر الحضور عند اللقطة',
  'saf.ui.notLocation': 'الحضور المسجّل ليس دليلًا على المكان الفعلي.',
  'saf.ui.people': 'الأشخاص في الموقع أو غير المؤكدين',
  'saf.ui.peopleSub': { one: 'شخص واحد · مندوبو التوصيل: {couriers} · مراجعات مفتوحة: {reviews}', other: '{count} أشخاص · مندوبو التوصيل: {couriers} · مراجعات مفتوحة: {reviews}' },
  'saf.ui.search': 'ابحث عن شخص',
  'saf.ui.filteredNote': 'يُعرض {shown} من {total}. الأعداد أعلاه للموقع كله.',
  'saf.ui.nobody': 'لا أحد مسجّل في الموقع.',
  'saf.ui.col.presence': 'الحضور',
  'saf.ui.col.otherFacts': 'حقائق أخرى (مستقلة)',
  'saf.ui.col.action': 'الإجراء',
  'saf.ui.col.anomaly': 'ما رُصد',
  'saf.ui.col.opened': 'فُتحت',
  'saf.ui.col.outcome': 'النتيجة',
  'saf.ui.col.record': 'سجّل نداء الأسماء',
  'saf.ui.col.source': 'المصدر',
  'saf.ui.col.mode': 'طريقة الإبلاغ',
  'saf.ui.col.freshness': 'الحداثة',
  'saf.ui.col.confirmedThrough': 'مكتمل حتى',
  'saf.ui.overdue': 'متأخر',
  'saf.ui.underReview': { one: 'مراجعة واحدة مفتوحة', other: '{count} مراجعات مفتوحة' },
  'saf.ui.credentialNote': 'تُعرض حالة البطاقة والاعتماد والزيارة بجانب الحضور. لا يضيف أيٌّ منها أحدًا إلى هذه القائمة ولا يحذفه منها.',
  'saf.ui.couriers': 'مندوبو التوصيل في الموقع',
  'saf.ui.vehicles': 'مركبات ما زالت في الموقع',
  'saf.ui.vehiclesSub': 'حضور المركبة حقيقة مستقلة؛ وجود مركبة متوقفة لا يعني وجود سائقها في الموقع.',
  'saf.ui.noVisit': 'لا توجد زيارة مرتبطة',
  'saf.ui.openMuster': 'افتح التجمّع الحالي',
  'saf.ui.startMuster': 'ابدأ التجمّع',
  'saf.ui.startSub': 'التقط كل من هو مسجّل في الموقع الآن في قائمة ثابتة. لا يطلق ذلك أي إنذار.',
  'saf.ui.startCounts': { zero: 'لن تضم القائمة أي شخص؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.', one: 'ستضم القائمة شخصًا واحدًا؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.', two: 'ستضم القائمة شخصين؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.', few: 'ستضم القائمة {count} أشخاص؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.', many: 'ستضم القائمة {count} شخصًا؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.', other: 'ستضم القائمة {count} شخص؛ متأخرون: {overdue}، سجلات حضور قيد المراجعة: {reviews}.' },
  'saf.ui.kind': 'نوع الحدث',
  'saf.ui.kind.drill': 'تمرين',
  'saf.ui.kind.emergency': 'طوارئ حقيقية',
  'saf.ui.note': 'ملاحظة (اختيارية)',
  'saf.ui.confirmFreshness': 'قرأت تحذير الحداثة وأفهم أن القائمة قد تكون ناقصة.',
  'saf.ui.startDrill': 'ابدأ التمرين',
  'saf.ui.startEmergency': 'ابدأ تجمّع الطوارئ',
  'saf.ui.flagReview': 'أشِر إلى الحضور للمراجعة',
  'saf.ui.flagReviewSub': 'استخدم هذا عندما يكون لديك سبب للشك في الحضور المسجّل. يُعرض الشخص كغير مؤكد حتى يحسم أحدهم الأمر.',
  'saf.ui.reason': 'السبب',
  'saf.ui.presenceHistory': 'سجل الحضور',
  'saf.ui.presenceHistorySub': 'كل ملاحظة وكل تصحيح بعد المراجعة، بالترتيب. لا شيء هنا يُعدَّل.',
  'saf.ui.observations': 'الملاحظات',
  'saf.ui.recordedLate': 'سُجّلت لاحقًا',
  'saf.ui.reviews': 'مراجعات الحضور',
  'saf.ui.reviewsSub': 'الملاحظات المتأخرة أو المكررة أو المتناقضة من أي مصدر تفتح مراجعة بدلًا من إجابة واثقة.',
  'saf.ui.status': 'الحالة',
  'saf.ui.reviewStatus.open': 'مفتوحة',
  'saf.ui.reviewStatus.resolved': 'محسومة',
  'saf.ui.reviewStatus.all': 'الكل',
  'saf.ui.noReviews': 'لا توجد مراجعات حضور هنا.',
  'saf.ui.detectedBySystem': 'رُصدت تلقائيًا',
  'saf.ui.resolve': 'احسم المراجعة',
  'saf.ui.resolveSub': 'يُسجَّل قرارك بجانب الملاحظات؛ الملاحظات نفسها لا تتغير أبدًا.',
  'saf.ui.event.arrival': 'وصول',
  'saf.ui.event.departure': 'مغادرة',
  'saf.ui.source.reception': 'مكتب الاستقبال',
  'saf.ui.source.kiosk': 'كشك',
  'saf.ui.source.gate': 'بوابة',
  'saf.ui.source.system': 'النظام',
  'saf.ui.source.access_control': 'التحكم في الدخول',
  'saf.ui.source.edge_agent': 'وكيل طرفي',
  'saf.ui.source.other': 'أخرى',
  'saf.anomaly.out_of_order': 'وصلت الملاحظة متأخرة وخارج الترتيب',
  'saf.anomaly.duplicate_arrival': 'وصول بينما الشخص في الموقع بالفعل',
  'saf.anomaly.departure_without_arrival': 'مغادرة دون وصول',
  'saf.anomaly.manual': 'أشار إليها موظف',
  'saf.resolution.confirmed_onsite': 'تأكّد وجوده في الموقع',
  'saf.resolution.confirmed_departed': 'تأكّدت مغادرته',
  'saf.resolution.remains_unknown': 'ما زال غير معروف',
  'saf.resolution.no_change': 'الحضور المسجّل صحيح',
  'saf.ui.noOpenMuster': 'لا يوجد تجمّع مفتوح لهذا الموقع.',
  'saf.ui.musterHistory': 'التجمّعات في هذا الموقع',
  'saf.ui.noMusters': 'لم يبدأ أي تجمّع هنا بعد.',
  'saf.ui.musterStatus.open': 'مفتوح',
  'saf.ui.musterStatus.closed': 'مغلق',
  'saf.ui.snapshotLine': 'نقطة التجمّع: {assembly}. بدأه {by}. اللقطة:',
  'saf.ui.totals.roster': 'في القائمة',
  'saf.ui.totals.accounted': 'معروف وضعهم',
  'saf.ui.totals.unaccounted': 'غير معروف وضعهم',
  'saf.ui.totals.wholeEvent': 'الحدث كاملًا',
  'saf.ui.totals.unaccountedSub': 'الحدث كاملًا · تعارضات: {conflict} · مفقودون: {missing}',
  'saf.ui.totals.filtered': 'المصفّى: غير معروف وضعهم / المعروضون',
  'saf.ui.totals.filteredSub': 'القائمة المصفّاة فقط — وليس إجمالي الحدث',
  'saf.ui.roster': 'نداء الأسماء',
  'saf.ui.rosterSub': 'اللقطة ثابتة. تُضاف كل ملاحظة ولا تُستبدل؛ وتنتظر الخلافات التسوية.',
  'saf.ui.any': 'أي',
  'saf.ui.method': 'طريقة التأكيد',
  'saf.method.in_person': 'شخصيًا',
  'saf.method.radio': 'لاسلكي',
  'saf.method.phone': 'هاتف',
  'saf.method.list_check': 'مطابقة القائمة',
  'saf.method.other': 'أخرى',
  'saf.ui.reconcile': 'سوِّ التعارض',
  'saf.ui.reconcileSub': { one: 'ملاحظة واحدة متعارضة. اختر الحالة التي تأكدت منها واذكر كيف.', other: '{count} ملاحظات متعارضة. اختر الحالة التي تأكدت منها واذكر كيف.' },
  'saf.ui.reconciled': 'تسوية',
  'saf.ui.history': 'السجل',
  'saf.ui.historySub': 'اللقطة وكل ملاحظة نداء أسماء وحقائق الحضور اللاحقة والتصديرات.',
  'saf.ui.exports': 'التصديرات',
  'saf.ui.exportPrint': 'قائمة قابلة للطباعة',
  'saf.ui.exportCsv': 'قائمة CSV',
  'saf.ui.download': { one: 'تنزيل (صف واحد)', other: 'تنزيل ({rows} صفوف)' },
  'saf.ui.rows': { one: 'صف واحد', other: '{count} صفوف' },
  'saf.ui.close': 'أغلق التجمّع',
  'saf.ui.closeSub': 'السبب مطلوب حتى لو بقي أشخاص غير معروف وضعهم. لا يمكن تغيير التجمّع المغلق.',
  'saf.ui.alsoKnown': 'معروف أيضًا',
  'saf.ui.notices': 'إشعارات المضيفين — أُرسلت: {accepted}، بالانتظار: {queued}، لم تُسلَّم: {failed}.',
  'saf.ui.empty': 'لم يكن أحد مسجّلًا في الموقع عند اللقطة.',
  'saf.ui.sources': 'مصادر الحضور',
  'saf.ui.sourcesSub': 'المكاتب والأكشاك تكتب مباشرة. التغذيات تُبلغ إلى أي حد اكتملت؛ والتغذية التي تتوقف عن الإبلاغ تجعل القائمة قديمة.',
  'saf.ui.mode.synchronous': 'مباشرة',
  'saf.ui.mode.feed': 'تغذية متأخرة',
  'saf.ui.fresh.current': 'حديث',
  'saf.ui.fresh.stale': 'قديم',
  'saf.ui.fresh.never_reported': 'لم يُبلغ قط',
  'saf.ui.fresh.disabled': 'معطّل',
  'saf.ui.disable': 'عطّل',
  'saf.ui.enable': 'فعّل',
  'saf.ui.sourceKey': 'مفتاح المصدر',
  'saf.ui.sourceLabel': 'الاسم',
  'saf.ui.addSource': 'سجّل المصدر',
  'saf.ui.settings': 'إعدادات السلامة',
  'saf.ui.settingsDefault': 'يستخدم هذا الموقع القيم الافتراضية. الحفظ ينشئ إعدادات خاصة بالموقع.',
  'saf.ui.settingsSub': 'تُسجَّل التغييرات في سجل التدقيق.',
  'saf.ui.set.staleAfterMinutes': 'تُعدّ التغذية قديمة بعد (دقائق)',
  'saf.ui.set.exportTtlMinutes': 'تنتهي صلاحية تصديرات القائمة بعد (دقائق)',
  'saf.ui.set.notifyHostsOnEmergency': 'راسل المضيفين المسؤولين عند بدء تجمّع طوارئ',
  'saf.ui.set.notifyHostsOnDrill': 'راسل المضيفين المسؤولين عند بدء تمرين',
  'saf.ui.set.includeCouriers': 'ضمّن مندوبي التوصيل الموجودين في القائمة',
  'saf.ui.set.noShowAfterMinutes': 'عدم الحضور بعد (دقائق من بداية النافذة)',
  'saf.ui.set.noShowHint': 'اتركه فارغًا لتصنيف عدم الحضور فقط بعد انتهاء نافذة الزيارة.',

  // ------------------------------------------------------------ reports UI (module 15)
  'rpt.ui.eyebrow': 'Passage / التقارير',
  'rpt.ui.title': 'التقارير الإجمالية',
  'rpt.ui.intro': 'افهم التشغيل لا الهوية. كل رقم يوضح ما يعدّه وما يستبعده ومدى حداثته.',
  'rpt.ui.filters': 'عوامل تصفية التقرير',
  'rpt.ui.report': 'التقرير',
  'rpt.ui.unavailable': 'غير متاح لمؤسستك',
  'rpt.ui.sites': 'المواقع',
  'rpt.ui.singleSite': 'دمج المواقع يحتاج إلى قدرة تعدد المواقع.',
  'rpt.ui.from': 'من',
  'rpt.ui.to': 'إلى',
  'rpt.ui.attribution': 'نسبة القسم',
  'rpt.ui.attribution.historical': 'كما سُجّلت عند كل زيارة',
  'rpt.ui.attribution.current': 'القسم الحالي',
  'rpt.ui.listHint': 'افصل بين القيم المتعددة بفواصل.',
  'rpt.ui.state.arrived': 'وصل',
  'rpt.ui.state.cancelled': 'ملغاة',
  'rpt.ui.state.denied': 'مرفوض',
  'rpt.ui.state.no_show': 'لم يحضر',
  'rpt.ui.state.expected': 'متوقَّع / معلّق',
  'rpt.ui.state.unresolved_departure': 'مغادرة غير محسومة',
  'rpt.ui.state.active': 'تصنيف سارٍ',
  'rpt.ui.state.withdrawn': 'تصنيف مسحوب',
  'rpt.ui.detail': 'اعرض صفوفًا تحدد الهوية (تُسجَّل في سجل التدقيق)',
  'rpt.ui.run': 'شغّل التقرير',
  'rpt.ui.stale': 'تغيّرت عوامل التصفية منذ إنتاج هذه النتائج. شغّل التقرير مجددًا قبل التصدير.',
  'rpt.ui.scope': 'النطاق: {sites}',
  'rpt.ui.asOf': 'حتى',
  'rpt.ui.identifiable': 'صفوف تحدد الهوية',
  'rpt.ui.aggregate': 'إجمالي فقط',
  'rpt.ui.classifiedAt': 'آخر تصنيف للاستثناءات {time} UTC.',
  'rpt.ui.neverClassified': 'لم تُصنَّف الاستثناءات بعد لهذه المواقع.',
  'rpt.ui.chart': 'رسم بياني لـ {metric}',
  'rpt.ui.page': 'الصفوف {from}–{to}',
  'rpt.ui.pageReset': 'تغيّرت عوامل التصفية، العودة إلى الصفحة الأولى',
  'rpt.ui.nextPage': 'الصفحة التالية',
  'rpt.ui.format': 'الصيغة',
  'rpt.ui.format.csv': 'CSV',
  'rpt.ui.format.xlsx': 'Excel (XLSX)',
  'rpt.ui.format.html': 'قابل للطباعة (احفظه PDF)',
  'rpt.ui.export': 'اطلب التصدير',
  'rpt.ui.exportQueued': 'طُلب التصدير. سيظهر أدناه عند جاهزيته.',
  'rpt.ui.exports': 'تصديراتك',
  'rpt.ui.exportsSub': 'تنتهي صلاحية التصديرات. يُعاد التحقق من صلاحيتك عند التنزيل.',
  'rpt.ui.job.queued': 'قيد الإعداد',
  'rpt.ui.job.ready': 'جاهز',
  'rpt.ui.job.failed': 'فشل',
  'rpt.ui.job.denied': 'رُفض — تغيّرت الصلاحية',
  'rpt.ui.job.expired': 'منتهي الصلاحية',
  'rpt.ui.download': 'تنزيل',
  'rpt.ui.schedules': 'التقارير المجدولة',
  'rpt.ui.schedulesSub': 'يُعاد التحقق من المستلمين في كل تشغيل؛ ومن فقد صلاحيته يُحجب عنه التقرير ولا يُراسَل.',
  'rpt.ui.newSchedule': 'جدول هذا التقرير',
  'rpt.ui.newScheduleSub': 'يتلقى المستلمون إشعارًا بأن التقرير جاهز في Passage — لا يُرسل التقرير نفسه بالبريد أبدًا.',
  'rpt.ui.noSchedules': 'لا توجد تقارير مجدولة بعد.',
  'rpt.ui.scheduleName': 'الاسم',
  'rpt.ui.cadence': 'التكرار',
  'rpt.ui.cadence.daily': 'يومي',
  'rpt.ui.cadence.weekly': 'أسبوعي',
  'rpt.ui.cadence.monthly': 'شهري',
  'rpt.ui.weekday': 'يوم الأسبوع (1 = الاثنين)',
  'rpt.ui.monthDay': 'يوم الشهر (1–28)',
  'rpt.ui.localTime': 'الوقت المحلي',
  'rpt.ui.period.previous_day': 'اليوم السابق',
  'rpt.ui.period.previous_7_days': 'الأيام السبعة السابقة',
  'rpt.ui.period.previous_month': 'الشهر التقويمي السابق',
  'rpt.ui.recipients': 'المستلمون',
  'rpt.ui.recipientsHint': 'لا يُدرج إلا من يمكنه قراءة هذه التقارير في كل المواقع المختارة.',
  'rpt.ui.scheduleStatus.active': 'نشط',
  'rpt.ui.scheduleStatus.disabled': 'معطّل',
  'rpt.ui.nextRun': 'التشغيل التالي',
  'rpt.ui.wouldBeWithheld': 'سيُحجب عنه',

  // ------------------------------------------------------------ audit UI
  'audit.ui.search': 'بحث',
  'audit.ui.clear': 'مسح',
  'audit.ui.actionHint': 'إجراء محدد، أو بادئة تنتهي بنقطة مثل «auth.»',
  'audit.ui.breadth': 'البحث دون منفّذ أو سجل أو مرجع يغطي حتى 31 يومًا؛ والبحث الأضيق حتى 366 يومًا.',
  'audit.ui.detail': 'حدث تدقيق',
  'audit.ui.detailSub': 'للقراءة فقط. فتح قيم قبل/بعد يُسجَّل بدوره.',
  'audit.ui.changesHidden': 'قيم قبل/بعد تحتاج صلاحية التدقيق الحساس المنفصلة.',
  'audit.ui.correlation': 'نشاط مرتبط',
  'audit.ui.correlationSub': 'كل ما سُجّل تحت مرجع واحد في هذه المؤسسة.',
  'audit.ui.events': 'أحداث التدقيق',
  'audit.ui.jobs': 'المهام الخلفية',
  'audit.ui.providers': 'مراجع المزوّدين',
  'audit.ui.attempts': { one: 'محاولة واحدة', other: '{count} محاولات' },
  'audit.ui.jobsOrgOnly': 'تُعرض المهام الخلفية ومراجع المزوّدين لمدققي المؤسسة كلها فقط.',
  'audit.ui.export': 'صدّر سجلات التدقيق',
  'audit.ui.exportSub': 'يحتاج إلى صلاحية تصدير التدقيق. يُسجَّل التصدير وكل تنزيل.',
  'audit.ui.includeChanges': 'ضمّن قيم قبل/بعد (تحتاج صلاحية التدقيق الحساس)',
  'audit.ui.exportQueued': 'طُلب التصدير. سيظهر في تصديراتك عند جاهزيته.',
};
